// extracted by mini-css-extract-plugin
module.exports = {"primary":"IconButton_primary__VNivC","gradient":"IconButton_gradient__2Wlvv","secondary":"IconButton_secondary__3jvdr"};